<template>
<svg viewBox="0 0 49 49" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-font-select`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_55984dbc61__clip0_1:462)"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.837 6.001c.418 0 .799.26.956.651l13.24 32.999A.975.975 0 0132.134 41h-2.136c-.417 0-.798-.26-.955-.65L24.076 28h-12.69L7.085 40.353a.965.965 0 01-.917.647H4.029A1.035 1.035 0 013 40a.986.986 0 01.054-.352L14.516 6.65a.965.965 0 01.918-.648h3.403zM44.343 35a1 1 0 011 1v2a1 1 0 01-1 1h-7.135a1 1 0 01-.92-.607l-.854-2a1 1 0 01.92-1.393h7.989zm-.226-14a1 1 0 011 1v2a1 1 0 01-1 1H31.925a1 1 0 01-.928-.628l-.802-2A1 1 0 0131.123 21h12.994zm-26.842-9.913L12.78 24h9.689l-5.193-12.913zM44.265 8a1 1 0 011 1v2a1 1 0 01-1 1H27.063a1 1 0 01-.93-.631l-.793-2A1 1 0 0126.27 8h17.995z"/></g><defs><clipPath id="svg_55984dbc61__clip0_1:462"><path d="M0 0h48.079v48.001H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconFontSelect',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
